// extracted by mini-css-extract-plugin
export default {"container":"dateForm_container__ttbDz","invoice_detail_description":"dateForm_invoice_detail_description__TdazZ"};